var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtmlIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_6485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint0_radial_752_6485)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_752_6485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8843 6H15.1157C10.0813 6 6 10.0812 6 15.1157V32.8843C6 37.9188 10.0813 42 15.1157 42H32.8843C37.9188 42 42 37.9188 42 32.8843V15.1157C42 10.0812 37.9188 6 32.8843 6Z",
    fill: "url(#paint1_linear_752_6485)",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.6381 32.4008L15 13.5H33L31.3602 32.3978L23.989 34.5L16.6381 32.4008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 32.8266L29.972 31.132L31.377 15.0222H24V32.8266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9991 21.9895H21.0405L20.8361 19.6192H23.9991V17.3043H23.9914H18.3926L18.4461 17.9254L18.9956 24.3043H23.9991V21.9895Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9978 28.0979L23.988 28.1006L21.5155 27.3946L21.3575 25.522H20.1561H19.1289L19.4399 29.2085L23.9875 30.5437L23.9978 30.5407V28.0979Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 22.0211V24.3633H26.7356L26.4777 27.401L24 28.1061V30.5429L28.5543 29.2121L28.5877 28.8164L29.1097 22.6501L29.1639 22.0211H28.5653H24Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 17.3043V18.722V19.5814V19.5869H29.399V19.5869H29.4062L29.4511 19.0739L29.553 17.9167L29.6066 17.3043H24Z",
    fill: "#EBEBEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_752_6485",
    x: -7.33333,
    y: -7.33333,
    width: 62.6667,
    height: 62.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 6.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_752_6485"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_752_6485",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_752_6485",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24 24) scale(24)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C9AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_752_6485",
    x1: 24.4666,
    y1: -0.270652,
    x2: 23.0959,
    y2: 71.0163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FAFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_6485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlIcon);
export default __webpack_public_path__ + "static/media/html-icon.ecf43b6c9db449885111d3e17655f2b5.svg";
export { ForwardRef as ReactComponent };